/**
 * 多维分析和号码包管理页面的 拖拽相关
 */
export default {
  dbl_sortable_drag_drag_and_drop: "拖动添加",
  dbl_sortable_drag_batch_add_or_drag_drop: "批量添加或拖拽",
  dbl_sortable_drag_lease: "至少",
  dbl_sortable_drag_release_mouse: "释放鼠标",
  dbl_sortable_drag_search_result: "搜索结果（{length}）",
  dbl_sortable_drag_loading: "数据加载中...",
	
  dbl_sortable_drag_input_number: "数值",
  dbl_sortable_drag_input_number_placeholder: "输入数值",
  dbl_sortable_drag_overall: "聚合数据",
  dbl_sortable_drag_255_tip: "展示所有{text}的去重用户数据",
  dbl_sortable_drag_all_unique: "全部（去重）",
  dbl_sortable_drag_all_sum: "全部（求和）",

  dbl_sortable_drag_dimension_map_set: "映射关系设置",
  dbl_sortable_drag_dimension_map_require: "不能为空",
  dbl_sortable_drag_dimension_map_max: "最多20个字符",
  dbl_sortable_drag_dimension_map_icon: "选择icon",
  dbl_sortable_drag_dimension_map_name: "输入展示维度值",
  dbl_sortable_drag_dimension_map_value: "匹配字段值选择",
  dbl_sortable_drag_dimension_map_name_duplicate: "名称重复",

  dbl_sortable_drag_dimension_icon_column_category: "分类",
  dbl_sortable_drag_dimension_icon_category_platform: "平台",
  dbl_sortable_drag_dimension_icon_category_sentiment: "情感值",
  dbl_sortable_drag_dimension_icon_category_country: "国家",
  dbl_sortable_drag_dimension_icon_category_others: "其他",
  dbl_sortable_drag_dimension_icon_name_xbox: "Xbox",
  dbl_sortable_drag_dimension_icon_name_epics: "Epic",
  dbl_sortable_drag_dimension_icon_name_steam: "Steam",
  dbl_sortable_drag_dimension_icon_name_playstation: "PlayStation",
  dbl_sortable_drag_dimension_icon_name_nintendo: "Nintendo",
  dbl_sortable_drag_dimension_icon_name_sentiment_positive: "积极",
  dbl_sortable_drag_dimension_icon_name_sentiment_negative: "消极",
  dbl_sortable_drag_dimension_icon_name_sentiment_neutral: "中立",
  dbl_sortable_drag_dimension_icon_name_default: "默认",
  dbl_sortable_drag_dimension_icon_name_iphone: "iPhone",
  dbl_sortable_drag_dimension_icon_name_monitor: "显示器",
  dbl_sortable_drag_dimension_icon_name_console_line: "主机",
  dbl_sortable_drag_dimension_icon_search_placeholder: "搜索图标名称、国家（支持中英）",
  dbl_sortable_drag_dimension_icon_search_no_results: "无匹配结果",

  // de-duplicated
  // dbl_sortable_drag_include: "包含",
  // dbl_sortable_drag_exclude: "不包含",
  // dbl_sortable_drag_greater: "大于",
  // dbl_sortable_drag_less: "小于",
  // dbl_sortable_drag_greaterOrEqual: "大于等于",
  // dbl_sortable_drag_lessOrEqual: "小于等于",
  // dbl_sortable_drag_equal: "等于",
  // dbl_sortable_drag_notEqual: "不等于",
  // dbl_sortable_drag_between: "区间",
  // dbl_sortable_drag_notNul: "有值",
  // dbl_sortable_drag_sum: "总和",
  // dbl_sortable_drag_avg: "均值",
  // dbl_sortable_drag_max: "最大值",
  // dbl_sortable_drag_min: "最小值",
  // dbl_sortable_drag_avgpp: "人均值",
  // dbl_sortable_drag_distinct: "去重数",
  // dbl_sortable_drag_count: "计数",
  // dbl_sortable_drag_variance: "方差",
  // dbl_sortable_drag_std: "标准差",

};